import GenericErrorAlert from './GenericErrorAlert';

export default GenericErrorAlert;
export * from './GenericErrorAlert';
